import { AgResourceLanguage } from '../types';

export const settingsPage: AgResourceLanguage['settingsPage'] = {
  title: 'Einstellungen',
  emailAndPassword: {
    changePasswordButton: 'Passwort ändern',
    emailChangeInfo: {
      informationText: 'Die E-Mail-Adresse kann nur durch den',
      linkText: 'Kundenservice geändert werden'
    },
    title: 'E-Mail und Passwort'
  },
  userInfo: {
    editButton: 'Bearbeiten',
    title: 'Vollständiger Name'
  },
  modal: {
    changePassword: {
      cancelButton: 'Zurück',
      confirmPasswordLabel: 'Bestätige das Passwort',
      header: 'Passwort ändern',
      infoBanner: 'Wenn du dein Passwort änderst, wirst du automatisch abgemeldet',
      newPasswordLabel: 'Neues Passwort',
      saveButton: 'Sparen',
      title: 'Passwort ändern',
      success: 'Das Passwort wurde geändert',
      reloginError: 'Etwas ist schief gelaufen. Bitte versuche es erneut'
    },
    editFullName: {
      cancelButton: 'Zurück',
      firstName: 'Vorname',
      header: 'Vollständigen Namen bearbeiten',
      lastName: 'Nachname',
      saveButton: 'Sparen',
      title: 'Vollständiger Name'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Vollständiger Name erfolgreich geändert',
    PASSWORD_MATCH_MESSAGE: 'Die Passwörter stimmen nicht überein',
    SETTINGS_ERROR: 'Etwas ist schief gelaufen. Bitte versuche es erneut',
    nameError: 'Muss mindestens 1 Zeichen lang sein',
    latinNameError: 'Darf nur lateinische Zeichen enthalten',
    spacesNameError: 'Nur Leerzeichen sind nicht erlaubt',
    minLength: 'Mindestens 8 Zeichen',
    uppercase: '1 Großbuchstabe',
    lowercase: '1 Kleinbuchstabe',
    number: '1 Zahl',
    spacesPasswordError: 'Leerzeichen ist nicht erlaubt',
    passwordCaption: 'Muss mindestens 5 Zeichen lang sein'
  }
};
